
import ProductInfoCard from "./productInfoCard";
import BottomCart from "./bottom-cart";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { cartContext } from "../App";
import HeaderOther from "./header-other";
import './display-products-category.css';

export default function DisplayProductsCategory() {
    
    const { productDataList, maxAmountReached } = useContext(cartContext);
    const location = useLocation();
    const { category, name, categoryName } = location.state || [];

    const cat = category.split(',');
    const catName = String(categoryName).split(',')
    
    const [selectedName, setSelectedName] = useState(cat[0])
    const [data, setData] = useState(productDataList.filter((item) =>  cat[0] === item.data.category))

    function changeCategory(itemName) {
        console.log('cat name: ', itemName);
        const filteredData = productDataList.filter((item) => itemName === item.data.category)
        setData(filteredData);
    }
    console.log('data filtered: ', data)

    return (
        <>
            {
                maxAmountReached && (
                    <div className="max-amount-reached">
                        <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                    </div>
                )
            }
            <HeaderOther />
            <p className="category-headings-cat">{name}</p>
            <div className="display-products-category-box">
                <div className='category-right-side-box' style={{borderRight:'0.05px solid rgba(64, 64, 64, 0.5)', overflowY:'scroll', maxHeight:'100vh', minWidth:'70px', scrollbarWidth:'none'}}>
                    
                    {
                        cat.map((item, index) => (
                            <div
                                onClick={() => {
                                    setSelectedName(item);
                                    changeCategory(item);
                                }}
                                style={{
                                    borderRight: selectedName === item ? "3px solid green" : "none",
                                    display: "flex",
                                    flexDirection:'column',
                                    cursor: "pointer",
                                    padding: "5px",
                                    marginBottom:'10px'
                                }}
                            >
                                <img src={`/category/${item}.jpg`} className="category-img" style={{ width: '60px', height: '60px', borderRadius: '10px' }} />
                                <p style={{ maxWidth: '70px', fontWeight: selectedName === item ? '700':'400' , color: selectedName === item ? '#2c5f2d':'black', fontSize: '10px', textAlign: 'center', marginTop: '0px', marginBottom:'2px' }}>{ catName[index] }</p>
                            </div>
                        ))

                    }

                </div>
                <div className="container" style={{ overflowY:'scroll', maxHeight:'100vh'}}>
                    <ProductInfoCard dataList={data} />
                </div>
            </div>
            
            <BottomCart />
        </>    
    );
}
